export default __webpack_public_path__ + "static/media/logo2.6411a3f1.png";